export enum Gender {
  INVALID = 0,
  FEMALE = 1,
  MALE = 2,
  KIDS = 3,
}

// The binary customer gender
export enum CustomerGender {
  INVALID = 0,
  FEMALE = 1,
  MALE = 2,
  DIVERSE = 3,
  NEUTRAL = 4,
}

export enum Device {
  INVALID = 0,
  IOS_APP = 1,
  ANDROID_APP = 2,
  MOBILE_WEB = 3,
  DESKTOP = 4,
}

export enum CarrierName {
  INVALID = 0,
  BPOST = 1,
  DHL = 2,
  DHL_AT = 3,
  DHL_BPOST_BEL = 4,
  DHL_NL = 5,
  DHL_PL = 6,
  DHL_POST_AUT = 7,
  DHL_STD_NATIONAL = 8,
  DHL_STD_WORLD = 9,
  FAN_RO = 10,
  GLS_HU = 11,
  HERMES = 12,
  HERMES_KLV = 13,
  HERMES_POST_AUT = 14,
  HERMES_STD_NATIONAL = 15,
  OMNIVA_EE = 16,
  OMNIVA_LT = 17,
  OMNIVA_LV = 18,
  OMNIVA = 19,
  POST_CH = 20,
  POST_HU = 21,
  POST_NL = 22,
  POST_SK = 23,
  POST_SI = 24,
  // Hrvatska pošta
  POST_HR = 25,
  POST_BG = 26,
  ECONT_BG = 27,
  ECONT_HR = 28,
  PPL = 29,
  FASTWAY_IE = 31,
  GLS_FR = 32,
  GLS_DK = 33,
  DHL_SE = 34,
  POST_FI = 35,
  POST_IT = 36,
  CORR_ES = 37,
  CTT_PT = 38,
  TAXY_GR = 39,
  POST_NO = 40,
  BPOST_BE = 41,
  // Zásilkovna
  ZASIL_CZ = 42,
  // Colissimo
  COLI_FR = 43,
  ASENDIA = 44,
  ASENDIA_SA = 45,
  ASENDIA_IL = 46,
  ACS_GR = 47,
  ACS_CY = 48,
  BPOST_LU = 49,
  DS_TB_IT = 50,
  QUICK_CH = 51,
  UB_POST_PL = 52,
  ZASIL_SK = 53,
  UB_SEUR_ES = 54,
  BRT_IT = 55,
}

export enum CurrencyCode {
  INVALID = 0,
  CHF = 1,
  EUR = 2,
  PLN = 3,
  CZK = 4,
  HUF = 5,
  RON = 6,
  BGN = 7,
  HRK = 8,
  DKK = 9,
  SEK = 10,
  NOK = 11,
  USD = 12,
  SAR = 13,
  ILS = 14,
}

export interface RequestConfig {
  childShopId: number;
  shopId: number;
  device: Device;
  session?:
    | {
        $case: "customerSession";
        customerSession: CustomerSession;
      }
    | {
        $case: "guestSession";
        guestSession: GuestSession;
      };
}

export interface CustomerSession {
  authToken: string;
}

export interface GuestSession {
  sessionId: string;
}
